// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CaptureEventRequest, ClickEventRequest, CustomEventRequest, SearchEventRequest } from "@eisinc/App/CoveoConnector/Types/schema";
import isApiError from "@insite/client-framework/Common/isApiError";
import { post } from "@insite/client-framework/Services/ApiService";

const coveoUrl = "/api/xngage/coveo/v1/analyticswrite";
const captureEventUrl = "/api/xngage/coveo/v1/analyticswrite/CaptureEvent";

type Parameter = SearchEventRequest | ClickEventRequest | CustomEventRequest | CaptureEventRequest;

export const trackEvent = async (endpoint: string, parameter: Parameter) => {
    try {
        await post(`${coveoUrl}/${endpoint}`, parameter);
    } catch (error) {
        if (isApiError(error)) {
            return {
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
};

export const trackSearchEvent = async (parameter: SearchEventRequest) => {
    const result = await trackEvent("searchevent", parameter);
    return result;
};

export const trackClickEvent = async (parameter: ClickEventRequest) => {
    const result = await trackEvent("clickevent", parameter);
    return result;
};

export const trackCustomEvent = async (parameter: CustomEventRequest) => {
    const result = await trackEvent("customevent", parameter);
    return result;
};

export const trackCaptureEvent = async (parameter: Parameter) => {
    try {
        await post(`${captureEventUrl}`, parameter);
    } catch (error) {
        if (isApiError(error)) {
            return {
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
};
